export const navbarData = [
  {
    codSeccion: 2,
    routeLink: 'home',
    icon: 'fa fa-home',
    label: 'Home',
    tooltip: 'Home',
  },
  {
    codSeccion: 3,
    routeLink: 'cotizaciones',
    icon: 'fa fa-hand-holding-usd',
    label: 'Cotizaciones',
    tooltip: 'Cotizaciones',
  },
  {
    codSeccion: 4,
    routeLink: 'siniestros',
    icon: 'fas fa-user-injured',
    label: 'Siniestros',
    tooltip: 'Siniestros',
  },
  {
    codSeccion: 5,
    routeLink: 'consultas',
    icon: 'fas fa-comment-alt-lines',
    label: 'Consultas',
    tooltip: 'Consultas',
  },
  {
    codSeccion: 6,
    routeLink: 'pagos',
    icon: 'fa-solid fa-credit-card',
    label: 'Pagos',
    tooltip: 'Pagos',
  },
  {
    codSeccion: 7,
    routeLink: 'documentacion',
    icon: 'fas fa-books',
    label: 'Documentacion',
    tooltip: 'Documentacion',
  },
  {
    codSeccion: 8,
    routeLink: 'contacto',
    icon: 'fas fa-address-card',
    label: 'Contacto',
    tooltip: 'Contacto',
  },
  {
    codSeccion: 9,
    routeLink: 'consulta-asegurado-caramuto',
    icon: 'fas fa-search',
    label: 'Consulta Asegurados',
    tooltip: 'Consulta Asegurados',
  },
  {
    codSeccion: 11,
    routeLink: 'siniestros-caramuto',
    icon: 'fas fa-file-medical',
    label: 'Siniestros Caramuto',
    tooltip: 'Siniestros Caramuto',
  },
  {
    codSeccion: 10,
    routeLink: 'administrar-permisos',
    icon: 'fas fa-user-shield',
    label: 'Permisos',
    tooltip: 'Administrar Permisos',
  },
  {
    codSeccion: 1002,
    routeLink: 'administrar-parametros-producto',
    icon: 'fas fa-sliders-h',
    label: 'Parámetros',
    tooltip: 'Administrar Parámetros de Producto',
  },
];
